/* Note hover tooltip (W2-03). Tokens only. */

.tip {
  position: fixed;
  z-index: var(--z-tooltip);
  max-width: 250px;
  padding: var(--space-2) var(--space-3);
  border: var(--border-width) solid var(--color-border);
  border-radius: var(--radius-md);
  background: var(--color-surface-overlay);
  box-shadow: var(--shadow-md);
  color: var(--color-text);
  font-size: var(--text-xs);
  line-height: var(--leading-normal);
  pointer-events: none;
}

.title {
  font-weight: var(--weight-semibold);
}

.row {
  color: var(--color-text-muted);
}

.flag {
  margin-top: var(--space-0);
  padding-left: var(--space-2);
  border-left: 2px solid var(--color-warning);
  color: var(--color-text);
}
